import { useEffect, useRef, useState } from 'react';

const MIN_HEIGHT = 240;

// Chiều cao tối đa để phần tử kéo dài xuống gần đáy màn hình, chừa `bottomGap` px
export default function useMaxHeightToViewportBottom(bottomGap = 50) {
  const ref = useRef(null);
  const [maxHeight, setMaxHeight] = useState();

  useEffect(() => {
    const updateMaxHeight = () => {
      if (!ref.current) return;
      const { top } = ref.current.getBoundingClientRect();
      setMaxHeight(Math.max(window.innerHeight - top - bottomGap, MIN_HEIGHT));
    };

    updateMaxHeight();
    window.addEventListener('resize', updateMaxHeight);
    return () => window.removeEventListener('resize', updateMaxHeight);
  }, [bottomGap]);

  return [ref, maxHeight];
}
